import React from "react";

import Counter from "./Counter";

import "./Banner.scss";

export default class Banner extends React.Component {
    constructor(props) {
        super(props);
    }

    handleScrollToWidget() {
        window.PubHub.util.scrollTo(".pubhub-raffle", undefined, 86);
    }

    // Render spinning wheel
    renderLoading() {
        return (
            <div className="loading-container">
                <div className="pubhub-loading"></div>
            </div>
        );
    }

    renderContent() {
        const {countdown, isEntered, isRaffleEnded} = this.props;

        const title = (
            isRaffleEnded
            ? "The drawing is over, thank you!"
            : isEntered
            ? "Thanks for entering!"
            : !isEntered
            ? "Want a chance at winning a cool prize?"
            : undefined
        );

        return (
            <div className="banner-inner-contents h-100">
                <div className="row align-items-center h-100">
                    <div className="col-7 col-sm-8 col-lg-4">
                        <Counter
                            countdown={countdown}
                            compact={true}
                        />
                    </div>

                    <div className="col-12 col-lg-5 d-flex flex-first flex-lg-unordered align-items-center justify-content-lg-center">
                        {!isRaffleEnded && <div className="d-none d-lg-block banner-gift-icon fas fa-gift"></div>}

                        <div className="banner-title">{title}</div>
                    </div>

                    <div className="col-5 col-sm-4 col-lg-3 d-flex justify-content-end">
                        {
                            !isEntered
                            && !isRaffleEnded
                            && (
                                <button
                                    className={`banner-info-btn`}
                                    onClick={this.handleScrollToWidget}
                                >
                                    <span className="banner-info-btn-sm-text">Enter drawing</span>
                                    <span className="banner-info-btn-text">Enter the drawing</span>
                                </button>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {isLoading} = this.props;
        const content = isLoading ? this.renderLoading() : this.renderContent();

        return (
            <div id="pubhub-raffle-banner" className="banner">
                <div className="banner-abstract-left"></div>

                <div className="banner-abstract-right"></div>

                <div className="container h-100">
                    {content}
                </div>
            </div>
        );
    }
}
